@import './pk-mixed-chart.variables';

:host {
  @apply block w-full;
}
